import {SectionListElement} from "../../../../getPDFPages";
import {ItemI} from "../../../../../../shared";
import {Content} from "pdfmake/interfaces";
import {getNomenclatureItems} from "./getNomenclatureItems";
import {getSectionItemsNames} from "./getSectionItemsNames";
import {defPDFHeader} from "../../../../partsOfPage";
import {formatDate, primaryColor} from "../../../../consts";
import {getSpecificationTableHeader} from "./getSpecificationTableHeader";
import {getSpecificationTableBodyOneRow, ISpecificationTableOneRowParameters} from "./getSpecificationTableBodyOneRow";
import {ISectionLabelRow} from "../../../../types";


export const getJSONForSpecification = (sectionList: SectionListElement[], parts: ItemI[]): Content => {
    //Доступное количество строк (вычислено эмпирически)
    const availableCountRows = 24
    let currentRow = 1
    const json: Content = []
    sectionList.forEach((section, sectionIndex, sectionsListArr) => {
            const sectionRemainedNames = getNomenclatureItems(section.nomenklature)
            const sectionItemsNames = getSectionItemsNames(section, parts)
            const allRowsInSection: ISectionLabelRow[] = []
            if (sectionRemainedNames.length >= sectionItemsNames.length) {
                sectionRemainedNames.forEach((row, index) => {
                    const itemName = sectionItemsNames[index]
                    allRowsInSection.push({...row, ...(itemName ? itemName : {})})
                })
            } else {
                sectionItemsNames.forEach((row, index) => {
                    const remainedName = sectionRemainedNames[index]
                    allRowsInSection.push({...row, ...(remainedName ? remainedName : {})})
                })
            }

            allRowsInSection.forEach((item, index, itemsArr) => {
                const isLastRowInSection = itemsArr.length - 1 === index
                const isFirstItemRow = index === 0
                if (currentRow === 1) {
                    sectionIndex !== 0 && json.push(JSON.parse(JSON.stringify(defPDFHeader)));
                    json.push({
                        color: primaryColor,
                        text: `Спецификация от ${formatDate}`,
                        fontSize: 16,
                        bold: true,
                        margin: [20, 17, 0, 0],
                    });
                    json.push(getSpecificationTableHeader())
                    // if (Boolean(itemsArr[index - 1])) {
                    //     json.push(getSpecificationTableBodyOneRow({itemName: `Продолжение секции ${sectionIndex + 1}`}))
                    //     currentRow++
                    // }
                }
                if (index === 0) {
                    const rowParameters: ISpecificationTableOneRowParameters = {
                        section: isFirstItemRow ? section : undefined,
                        sectionIndexText: isFirstItemRow ? `${sectionIndex + 1}` : undefined,
                        ...item
                    }
                    json.push(getSpecificationTableBodyOneRow(rowParameters))
                    currentRow++
                } else {
                    currentRow++
                    if (currentRow === availableCountRows) {
                        json.push(getSpecificationTableBodyOneRow({
                            ...item,
                            isLastRowInSection,
                            isLastRowInPage: true
                        }))
                    } else {
                        json.push(getSpecificationTableBodyOneRow({...item, isLastRowInSection}))
                    }
                    // if (currentRow + 1 === availableCountRows && Boolean(itemsArr[index + 1])) {
                    //     json.push(getSpecificationTableBodyOneRow({
                    //         itemName: `Конец секции ${sectionIndex + 1}`,
                    //         isLastRowInPage: true
                    //     }))
                    //     currentRow++
                    // }
                }
                if (currentRow === availableCountRows) {
                    currentRow = 1
                }

            })
        }
    )
    if (availableCountRows - currentRow < 9) {
        json.push({text: '', pageBreak: 'after'})
        json.push(JSON.parse(JSON.stringify(defPDFHeader)))
    }
    return json;
}
